<div id="default-wrapper">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6 default-left-section">
        <img src="/assets/img/todo-list.svg" class="img-fluid" alt="Logowanie - obrazek ozdobny"/>
      </div>
      <div class="col-lg-6 default-right-section">
        <app-logo width="130px"></app-logo>
        <app-logo-slogan></app-logo-slogan>
        <p>
          System wspomagający audytorów podczas audytów i inspekcji<br>
          dotyczących bezpieczeństwa żywności.
        </p>

        <div class="default-section-router">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>
